export default "__VITE_PUBLIC_ASSET__89ec044d__"